export default __webpack_public_path__ + "static/media/c_negativo.45f65d28.svg";